import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BasicFieldCheckbox, BaasicFieldDropdown, DatePickerField, EditFormContent, BaasicButton} from 'core/components';

function PumpEditTemplate({ editView }) {
    const {
        form,
        pumpStore,
        duplicateItems
    } = editView;

    return (
        <div className="col col-sml-12 col-lrg-4">   
            <div className="card card--form card--primary card--med">     
            <EditFormContent form={form}>
                <div className="row">
                    <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                        <BaasicFieldDropdown field={form.$('productId')} store={pumpStore} />
                    </div>
                    <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                        <BasicInput field={form.$('serialNumber')} />
                    </div>
                    <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                        <DatePickerField field={form.$('dateSent')} />
                    </div>
                    <div className="form__group col col-lrg-6 u-flex--align-center">
                        <BasicFieldCheckbox field={form.$('stickered')}/>Sticker
                    </div>
                    <div className="form__group col col-lrg-6 u-flex--align-center u-flex--gap--2">
                        <span>Branch</span>
                        <div className='btn--toggled__wrap' style={{ display: 'inline-flex' }}>
                            {[{ value: 'Lakewood', label: 'Lkwd' }, { value: 'Chicago', label: 'Chi' }].map((option) => (
                                <button
                                    key={option.value}
                                    type="button"
                                    className={`btn btn--toggled ${form.$('branch').value === option.value ? 'btn--primary' : ''}`}
                                    onClick={() => form.$('branch').set(option.value)}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div>
                    {duplicateItems && duplicateItems > 0 &&
                        <div className="validation__message u-mar--bottom-tny"> 
                            <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>
                            There is already an active pump with this serial number in the system.
                        </div>
                    }
                    <BaasicButton
                        type='submit'
                        className='btn btn--base btn--primary'
                        label={duplicateItems && duplicateItems > 0 ? 'Add Anyway' : 'Add'}
                        rotate
                        icon={
                            form.submitting || form.validating
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                        onClick={form.onSubmit}
                    />
                </div>
            </EditFormContent>
            </div>
        </div>
    )
}

PumpEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PumpEditTemplate);
